import {createApp} from 'vue'
import {createPinia} from 'pinia'
// import './style.css'
import router from './router'
import App from './App.vue'
import {useAuthStore} from './store/auth'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.css';

const app = createApp(App)

// Add state management with a Pinia store instance
app.use(createPinia())

// Add the router to the app
app.use(router)

// Handle authentication
const authStore = useAuthStore()

// Make a request to the backend to set the CSRF token
authStore.setCsrfToken()

app.mount('#app')
